import script from "./fengchengOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./fengchengOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./fengchengOrderRecord.vue?vue&type=style&index=0&id=57af8426&lang=scss"

const __exports__ = script;

export default __exports__